export default "__VITE_ASSET__eAVAmGYV__"